/**
 * Reusable red-bg error banner with an optional inline retry button.
 *
 * Existed-in-multiple-places before: Today, Submit, SupervisorReview, and
 * every tab of Admin.jsx hand-rolled their own `{err && <div>...{err}</div>}`
 * block. Several of them left the worker/supervisor stuck on a "Loading…"
 * state when the fetch errored — no way to retry without navigating away.
 *
 * Using this component across the app gives us one spot to improve error
 * UX (e.g. classify network vs server errors, add a toast variant, etc.).
 */
export default function ErrorBanner({ message, onRetry, retryLabel = "Retry" }) {
  if (!message) return null;
  return (
    <div className="flex items-start justify-between gap-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">
      <span className="min-w-0 break-words">{message}</span>
      {onRetry && (
        <button
          type="button"
          className="tap shrink-0 rounded px-2 py-0.5 text-xs font-semibold text-red-800 underline active:text-red-900"
          onClick={onRetry}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}
